import React from 'react';
import signInAsset from '../assets/images/web_light_rd_SI.svg';
import signUpAsset from '../assets/images/web_light_rd_SU.svg';
import '../assets/css/google-sign-in-button.css';

/**
 * Official Google "Sign in" / "Sign up" assets (light, rounded).
 * Do not edit the SVGs — Google forbids changing G logo colors or monochrome G.
 * Layout-only CSS (width, spacing) is fine per branding guidelines.
 */
export default function GoogleSignInButton({ variant = 'signin', disabled = false, className = '', onClick }) {
  const src = variant === 'signup' ? signUpAsset : signInAsset;
  const label = variant === 'signup' ? 'Sign up with Google' : 'Sign in with Google';

  return (
    <button
      type="button"
      className={`google-sign-in-btn ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    >
      <img src={src} alt="" className="google-sign-in-btn__img" draggable={false} />
    </button>
  );
}
